import React from 'react'
import { Link } from 'react-router-dom'

const TwoStep = () => {
    return (
        <div className="flex justify-center">
            <div className="md:w-full p-7 bg-white border rounded auth-body">
                <form>
                    <ul className="grid list-none li_animate">
                        <li className="w-11/12">
                            <input
                                type="text"
                                className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0 text-center"
                                placeholder="-"
                                maxLength="1"
                                id='otp1'
                            />
                        </li>
                        <li className="w-11/12">
                            <input
                                type="text"
                                className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0 text-center"
                                placeholder="-"
                                maxLength="1"
                                id='otp2'
                            />
                        </li>
                        <li className="w-11/12">
                            <input
                                type="text"
                                className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0 text-center"
                                placeholder="-"
                                maxLength="1"
                                id='otp3'
                            />
                        </li>
                        <li className="w-11/12">
                            <input
                                type="text"
                                className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0 text-center"
                                placeholder="-"
                                maxLength="1"
                                id='otp4'
                            />
                        </li>
                        <li className="col-span-12 my-4">
                            <Link
                                className="block w-full py-3 bg-primary-900 text-white text-center rounded-lg uppercase hover:bg-primary-800 transition"
                                to="/"
                                title="Verify my account"
                                aria-label="Verify my account"
                            >
                                Verify my account
                            </Link>
                        </li>
                        <li className="col-span-12 text-center">
                            <span className="text-gray-500">
                                Haven't received it?
                                <Link className="ml-1 text-blue-500 hover:underline" to="/two-step" aria-label="Resend a new code">Resend a new code.</Link>
                            </span>
                        </li>
                    </ul>
                </form>
            </div>
        </div>

    )
}

export default TwoStep